import React from "react";

const items = [
  "✦ NMIA Airport Phase 1 — on track for 2025 launch",
  "✦ Atal Setu Operational — 35% property premium surge",
  "✦ Hiranandani Fortune City — pre-launch oversubscribed",
  "✦ NAINA approves 15,000 new residential plots in Ulwe",
  "✦ Metro Line Extension — 8 new stations confirmed",
  "✦ Ulwe micro-market — 45% appreciation in 24 months",
  "✦ Kharghar Golf Course corridor — record transactions",
  "✦ 500+ investors trust Sneha Reality for NM investments",
  "✦ Dronagiri commercial yields projected at 7.5% p.a.",
  "✦ Panvel growth corridor — infrastructure spend ₹3L Cr",
];

const MarqueeTicker = () => (
  <div className="py-3 overflow-hidden border-y relative"
    style={{
      borderColor: "rgba(212,175,55,0.15)",
      background: "linear-gradient(90deg, rgba(212,175,55,0.03), rgba(212,175,55,0.06), rgba(212,175,55,0.03))"
    }}
  >
    {/* Left fade */}
    <div className="absolute left-0 top-0 bottom-0 w-16 z-10"
      style={{ background: "linear-gradient(90deg, #080808, transparent)" }} />
    {/* Right fade */}
    <div className="absolute right-0 top-0 bottom-0 w-16 z-10"
      style={{ background: "linear-gradient(270deg, #080808, transparent)" }} />

    <div className="flex whitespace-nowrap" style={{ animation: "marqueeScroll 40s linear infinite" }}>
      {[...items, ...items].map((item, i) => (
        <span key={i} className="inline-flex items-center mx-8 text-xs tracking-[0.15em] font-heading font-light"
          style={{ color: i % 3 === 0 ? "#D4AF37" : "rgba(250,248,243,0.45)" }}>
          {item}
        </span>
      ))}
    </div>
  </div>
);

export default MarqueeTicker;
